import React, { lazy } from "react";
import {
  BrowserRouter as Router,
  Route,
  Routes,
} from "react-router-dom";
import { Redirect } from "../components/Redirect";
import NewLanding1 from "../components/Layout/NewLanding1";
// import NewLanding1 from "../components/Layout/NewLanding1";
import RedirectToAmazon from "../components/RedirectToAmazon";
const ProtectedRouteNew = lazy(() => import('./ProtectedRouteNew'));
const AuthProvider = lazy(() => import('./../components/AuthProvider'));
const MainLayout = lazy(() => import('../components/Layout/MainLayout'));
const DealersList = lazy(() => import('../components/Dealer/DealersList'));
const TowQRScanner = lazy(() => import('../components/Towing/TowQRScanner'));
const ImageCarousel = lazy(() => import('../components/Layout/ImageCarousel'));
const LandingBuy = lazy(() => import('../components/Adlanding/LandingBuy'));
// const Landing = lazy(() => import('../components/Layout/Landing'));
const QRScanner = lazy(() => import('../components/QRScan/QRScanner'));
const Chat = lazy(() => import('../components/Chat'));
const NewLogin = lazy(() => import('../components/Login/NewLogin'));
const Contacts = lazy(() => import('../components/Contact'));
const SalesDashboardNew = lazy(() => import('../components/Sales/SalesDashboardNew'));
const Profile = lazy(() => import('../components/Profile/Profile'));
const UserManagementTableNew = lazy(() => import('../components/UserManagement/UserManagementTableNew'));
const InvalidQR = lazy(() => import('../components/QRScan/InvalidQR'));

const AppRoutesNew: React.FC = () => {
  return (
    <Router>
      <Routes>
        {/* Public Routes */}
        <Route path='/' element={<AuthProvider><NewLanding1 /></AuthProvider>} />
        <Route path='/buy' element={<LandingBuy />} />
        {/* <Route path='/new' element={<NewLanding />} />
        <Route path='/new1' element={<NewLanding1 />} />
        <Route path='/new2' element={<NewLanding2 />} />
        <Route path='/new3' element={<NewLanding2 />} />
        <Route path='/new4' element={<NewLanding4 />} />
        <Route path='/new5' element={<NewLanding5 />} /> */}
        <Route path='/d2amazon' element={<RedirectToAmazon />} />
        <Route path='/gallery' element={<ImageCarousel />} />

        <Route path='/login' element={<AuthProvider><NewLogin /></AuthProvider>} />
        <Route
          path='/functions/v1/verify-scan/:qrCode'
          element={<AuthProvider><Redirect /></AuthProvider>}
        />
        <Route path='/invalid' element={<AuthProvider><InvalidQR /></AuthProvider>} />
        <Route
          path='/chat'
          element={
            <AuthProvider><ProtectedRouteNew>
              <MainLayout />
            </ProtectedRouteNew>
            </AuthProvider>
          }
        >
          <Route
            path='/chat'
            element={
              <AuthProvider><ProtectedRouteNew requiredRoles={['admin', 'support']}>
                <Chat />
              </ProtectedRouteNew></AuthProvider>
            }
          />
          <Route
            path='/chat/:userId'
            element={
              <AuthProvider><ProtectedRouteNew requiredRoles={['admin', 'support']}>
                <Chat />
              </ProtectedRouteNew></AuthProvider>
            }
          />
          <Route
            path='/chat/support/:supportId'
            element={
              <AuthProvider><ProtectedRouteNew requiredRoles={['admin', 'support']}>
                <Chat />
              </ProtectedRouteNew></AuthProvider>
            }
          />
          <Route
            path='/chat/contacts'
            element={
              <AuthProvider><ProtectedRouteNew requiredRoles={['admin', 'support']}>
                <Contacts />
              </ProtectedRouteNew></AuthProvider>
            }
          />
          <Route
            path='/chat/qrscan'
            element={
              <AuthProvider><ProtectedRouteNew requiredRoles={['admin', 'sales']}>
                <QRScanner />
              </ProtectedRouteNew>
              </AuthProvider>
            }
          />

          <Route
            path='/chat/profile'
            element={
              <AuthProvider><ProtectedRouteNew >
                <Profile />
              </ProtectedRouteNew></AuthProvider>
            }
          />

          <Route
            path='/chat/sales'
            element={
              <AuthProvider><ProtectedRouteNew requiredRoles={['admin', 'sales']}>
                <SalesDashboardNew />
              </ProtectedRouteNew></AuthProvider>
            }
          />

          <Route
            path='/chat/roles'
            element={
              <AuthProvider><ProtectedRouteNew requiredRoles={['admin']}>
                <UserManagementTableNew />
              </ProtectedRouteNew>
              </AuthProvider>
            }
          />
          <Route
            path='/chat/dealers'
            element={
              <AuthProvider><ProtectedRouteNew requiredRoles={['admin']}>
                <DealersList />
              </ProtectedRouteNew>
              </AuthProvider>
            }
          />
          <Route
            path='/chat/towing'
            element={
              <AuthProvider>
                <ProtectedRouteNew requiredRoles={['admin', 'towman']}>
                  <TowQRScanner />
                </ProtectedRouteNew>
              </AuthProvider>
            }
          />
        </Route>
        {/* <Route path='*' element={<AuthProvider><Navigate to='/' replace /></AuthProvider>} /> */}
      </Routes>
    </Router>
  );
};

export default AppRoutesNew;
